import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import MostSellingWorkwear from '../components/Home/MostSellingWorkwear';
import ProductDetails from '../components/SingleProduct/ProductDetails';
import Hero from '../components/SingleProduct/Hero';
import { fetchProduct } from '../services/productApi';

const Product = () => {
  const params = useParams();
  const [searchParams] = useSearchParams();
  const idFromQuery = searchParams.get('id');
  const id = params.id || idFromQuery;
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!id) return;
    (async () => {
      setLoading(true);
      setError('');
      try {
        const p = await fetchProduct(id);
        setProduct(p);
      } catch (e) {
        setError(e.message || 'Failed to load product');
      } finally {
        setLoading(false);
      }
    })();
  }, [id]);

  return (
    <div>
      <Hero product={product} loading={loading} error={error} />
      <div className="h-10 sm:h-20 md:h-[120px] lg:h-[202px]"></div>
      <ProductDetails product={product} loading={loading} error={error} />
      <div className="mt-20 md:mt-[150px]">
        <MostSellingWorkwear />
      </div>
    </div>
  );
};

export default Product;
